export default __webpack_public_path__ + "static/pragicts-secops-services-firewall-security-ba82a9ce4c8a509f41ac17034381de7c.jpg";